import React from "react";
import ReactDOM from "react-dom";
import App from "./containers/App";
import * as serviceWorker from "./serviceWorker";
import "url-search-params-polyfill";
import "es7-object-polyfill";
import TagManager from 'react-gtm-module'

import "./index.scss";

//import $ from "jquery";
//import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";

import "react-bootstrap-typeahead/css/Typeahead-bs4.css";

import ErrorBoundary from "./components/ErrorBoundary";

const tagManagerArgs = {
  gtmId: 'AW-11081935266'
};

// Track if GTM has been initialized to prevent double initialization
let gtmInitialized = false;

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

// Function to initialize GTM
const initializeGTM = () => {
  if (!gtmInitialized && window.Cookiebot && window.Cookiebot.consent && window.Cookiebot.consent.marketing) {
    gtag('set', 'linker', {
      'domains': ['feuersozietaet.de', 'www.feuersozietaet.de', 'sicherelaube.de', 'www.sicherelaube.de', 'dev.sicherelaube.de']
    });
    TagManager.initialize(tagManagerArgs);
    gtmInitialized = true;
  }
};

// Initialize GTM if marketing cookies are already accepted
initializeGTM();

// Listen for Cookiebot consent changes
window.addEventListener('CookiebotOnAccept', function () {
  initializeGTM();
});


ReactDOM.render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
